<cwo-expandable-component (isExpanded)="handleExpansion($event)" [headerStyle]="'fullWidth'"
    [overflowVisible]="expanded" [expandedInput]="expanded" [ariaControlsName]="groupName()" [id]="groupExpandableId()"
    [ngStyle]="{'scroll-margin-top': scrollMarginTop + 'px'}" [style.--expand-duration]="'0s'">
    <ng-template #heading>
        <div class="header">
            <cwo-icon [name]="iconNameType.arrow" class="icon"
                [ngStyle]="{transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)'}" />
            <span class="label">{{groupName()}} </span>
        </div>
    </ng-template>
    <ng-template #content>
        <div class="content-wrapper" [id]="groupExpandableId() + 'content'">
            <ng-container [ngTemplateOutlet]="ingredientsList() ?? noContent"></ng-container>
        </div>
    </ng-template>
</cwo-expandable-component>



<ng-template #noContent>
    <div>{{'No Content provided'}}</div>
</ng-template>